import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { isSuperUser } from "../../utils/adminSession";

/**
 * Keeps non super users out of super-user-only pages. The API enforces the same
 * rule; this just avoids showing a page whose every request would be refused.
 */
const SuperUserRoute: React.FC = () => {
  if (!isSuperUser()) {
    return <Navigate to="/mosaic/users" replace />;
  }

  return <Outlet />;
};

export default SuperUserRoute;
